export const types = {
  'SET_ROUTE_TITLE': 'setRouteTitle',
  'SET_ROUTE_ACTION_DATA': 'setRouteActionData'
};
